import React, { useEffect, useState } from 'react';
import { Modal, Button, InputGroup, Form } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import CloseIcon from '../../layouts/SVG/CloseIcon';
import searchIcon from '../../assets/SidebarIcons/icon-search.svg';
import RouteCreateModel from './GatewayRouteCreateModel';
import RouteDeleteModel from './GatewayRouteDeleteModel';

const GatewayRoutesListModel = ({ onShow, routesList, setRoutesModelShow, refreshData, refreshUserRoutes }) => {
  const [search, setSearch] = useState('');
  const [searchData, setSearchData] = useState(routesList);
  const [routeCreateModelShow, setRouteCreateModelShow] = useState(false);
  const [routeDeleteModelShow, setRouteDeleteModelShow] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});

  const columns = [
    { name: 'Route Name', sortable: true, selector: (row) => row.route_name },
    { name: 'Ani', sortable: true, selector: (row) => row.ani },
    { name: 'Updated Date', sortable: true, selector: (row) => row.updated_at },
    {
      name: 'Actions',
      minWidth: '250px',
      selector: (row) => (
        <div className="d-flex justify-content-center align-items-center gap-1">
          <Button variant="danger" onClick={() => openDeleteModel(row)} style={{ minWidth: 100 }}>
            Delete
          </Button>
        </div>
      ),
    },
  ];

  const handleClose = () => {
    setRoutesModelShow(false);
  };

  const onSearch = (evt) => {
    const { value } = evt.target;
    const filteredData = routesList.filter((item) =>
      item.route_name.toLowerCase().includes(value.toLowerCase())
    );

    setSearch(value);
    setSearchData(value ? filteredData : routesList);
  };

  const openModel = () => {
    setRouteCreateModelShow(true);
    setRoutesModelShow(false);
  };

  const openDeleteModel = (row) => {
    setSelectedRow(row);
    setRouteDeleteModelShow(true);
    setRoutesModelShow(false);
  };

  useEffect(() => {
    setSearchData(routesList);
  }, [routesList]);

  return (
    <>
      <Modal show={onShow} onHide={handleClose} centered size="xl">
        <Modal.Header>
          <div className="w-100 d-flex justify-content-between align-items-center">
            <Modal.Title as="h4" style={{ margin: '16px 0 8px 8px' }}>
              Gateway Route List
            </Modal.Title>
            <div className="d-flex gap-2">
              <InputGroup className="datatable-search">
                <InputGroup.Append>
                  <InputGroup.Text>
                    <img alt="..." src={searchIcon} />
                  </InputGroup.Text>
                </InputGroup.Append>
                <Form.Control
                  placeholder="Search..."
                  name="search"
                  value={search}
                  onChange={onSearch}
                />
              </InputGroup>
              <Button variant="primary" onClick={() => openModel()} style={{ minWidth: 160 }}>
                Add New Route
              </Button>
              <CloseIcon handleModalClose={handleClose} />
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className="gateway-route-list-modal">
          <DataTable columns={columns} data={searchData} pagination />
        </Modal.Body>
      </Modal>
      <RouteCreateModel
        onShow={routeCreateModelShow}
        setRouteCreateModelShow={setRouteCreateModelShow}
        setRoutesModelShow={setRoutesModelShow}
        refreshData={refreshData}
        refreshUserRoutes={refreshUserRoutes}
      />
      <RouteDeleteModel
        onShow={routeDeleteModelShow}
        setRouteDeleteModelShow={setRouteDeleteModelShow}
        setRoutesModelShow={setRoutesModelShow}
        data={selectedRow}
        refreshData={refreshData}
        
      />
    </>
  );
};

export default GatewayRoutesListModel;
